import { DaymapQuery as r } from "../daymapQuery.js";
var l;
((t) => {
  class m extends r {
    constructor() {
      super(
        ["formListStudents"],
        null,
        "/lms/api/forms/lists/student?hideCalendarForms=false",
        null,
        {
          stale: 1e3 * 60 * 5
        }
      );
    }
  }
  t.FormListStudents = m;
  class s extends r {
    constructor({ studentId: e, includeExpired: d, year: n }) {
      let i = `/lms/api/records/studentsummary?studentId=${e}`, c = ["studentsummary", e, d], u = { studentId: e, includeExpired: d };
      n !== void 0 && (i += `&from=${n}-01-01&to=${n}-12-31`, c.push(n), u.year = n), i += `&includeExpired=${d}`, super(
        c,
        u,
        i,
        null,
        {
          stale: 1e3 * 60 * 2
        }
      );
    }
  }
  t.StudentSummary = s;
  class o extends r {
    constructor(e) {
      let d = `/lms/api/records/list/student?studentId=${e.studentId}&id=${e.studentId}&formId=${e.formId}`, n = ["recordliststudent", e.studentId, e.formId, e.includeExpired];
      e.year !== void 0 && (d += `&from=${e.year}-01-01&to=${e.year}-12-31`, n.push(e.year)), d += `&includeExpired=${e.includeExpired}`, super(
        n,
        e,
        d,
        null,
        {
          select: (i) => {
            const c = i;
            return c.Records = c.Records.map((u) => ({ ...u, _created: new Date(u._created), _modified: new Date(u._modified) })), c;
          },
          stale: 1e3 * 60 * 2
        }
      );
    }
  }
  t.RecordListStudent = o;
  class I extends r {
    constructor(e) {
      super(
        ["record", e.formId, e.studentId, e.rowId],
        e,
        `/lms/api/forms/record?formid=${e.formId}&id=${e.studentId}${e.rowId ? " &rowId=" + e.rowId : ""}${e.editMode ? " &editMode=" + e.editMode : ""}&loadItems=true`,
        null
      );
    }
  }
  t.RecordDetails = I;
  class f extends r {
    constructor(e) {
      let d = "";
      e.id && (d += `&id=${e.id}`), e.rowId && (d += `&rowId=${e.rowId}`), e.navigate && (d += `&navigate=${e.navigate}`), e.editMode && (d += `&editMode=${e.editMode}`), e.actionId && (d += `&id=${e.actionId}`), super(
        ["RecordSave", e.formId, e.id, e.rowId, e.data],
        e,
        `/lms/api/forms/record/save?formId=${e.formId}${d}`,
        null,
        {
          enabled: !1
        }
      );
    }
  }
  t.RecordSave = f;
  class $ extends r {
    constructor(e) {
      super(
        ["recordAttachments", e.formId, e.studentId, e.rowId],
        e,
        `/lms/api/forms/record/attachments?formid=${e.formId}&id=${e.studentId}${e.rowId ? " &rowId=" + e.rowId : ""}`,
        null
      );
    }
  }
  t.RecordAttachments = $;
  class v extends r {
    constructor(e) {
      super(
        ["RecordFromEvent", e.eventId, e.studentId],
        e,
        `/lms/api/forms/record/recordFromEvent?Id=${e.eventId}&StudentId=${e.studentId}`,
        null
      );
    }
  }
  t.RecordFromEvent = v;
  class S extends r {
    constructor(e) {
      super(
        ["FormSchema", e.id],
        e,
        `/lms/api/forms/form/schema?id=${e.id}`,
        null,
        {
          stale: 1e3 * 60 * 5,
          enabled: e.enabled
        }
      );
    }
  }
  t.GetFormSchema = S;
})(l || (l = {}));
export {
  l as forms
};
//# sourceMappingURL=index.js.map
